import cn from 'classnames';
import { FC } from 'react';

import DownloadIcon from '@icons/18/download-icon.svg';

import OfficePhoneEmail from '../OfficePhoneEmail';
import styles from './OfficeCard.module.scss';
import { OfficeCardProps } from './types';

const OfficeCard: FC<OfficeCardProps> = ({
    title,
    schedule,
    address,
    phoneLabel,
    phoneTel,
    email,
    routeSchemeUrl,
    isWarehouse = false,
    isCompact = false,
}) => (
    <div
        className={cn(
            styles.officeCard_root,
            isCompact && styles.officeCard_compact,
            isCompact && isWarehouse && styles.officeCard_warehouseCompact
        )}
    >
        <h3 className={cn(styles.officeCard_title, isCompact && styles.officeCard_titleCompact)}>{title}</h3>
        <div className={cn(styles.officeCard_inner, isCompact && styles.officeCard_innerCompact)}>
            <p className={styles.officeCard_schedule}>{schedule}</p>
            <p className={styles.officeCard_address}>{address}</p>
            {routeSchemeUrl ? (
                <a
                    href={routeSchemeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.officeCard_download}
                >
                    <DownloadIcon className={styles.officeCard_downloadIcon} aria-hidden />
                    <span>Скачать схему проезда</span>
                </a>
            ) : null}
            <OfficePhoneEmail phoneLabel={phoneLabel} phoneTel={phoneTel} email={email} />
        </div>
    </div>
);

export default OfficeCard;
